import { render } from "./CargaDocumentosAspirante.vue?vue&type=template&id=67cbf57e&scoped=true"
import script from "./CargaDocumentosAspirante.vue?vue&type=script&lang=js"
export * from "./CargaDocumentosAspirante.vue?vue&type=script&lang=js"

import "./CargaDocumentosAspirante.vue?vue&type=style&index=0&id=67cbf57e&scoped=true&lang=css"

import exportComponent from "D:\\wamp\\www\\Proyectos\\LICEO\\portalalumnos\\portalalumnos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cbf57e"]])

export default __exports__